import React from "react";
import PropTypes from "prop-types";

import { motion } from "framer-motion";

const BasicLoader = ({ color, position, size }) => (
  <svg
    viewBox={`0 0 ${size} ${size}`}
    style={
      position === "relative"
        ? {
            width: `${size}px`,
            height: `${size}px`,
            overflow: "visible",
            margin: "0 auto",
            display: "block",
          }
        : {
            position: "absolute",
            left: "50%",
            top: "50%",
            marginTop: `-${size / 2}px`,
            marginLeft: `-${size / 2}px`,
            width: `${size}px`,
            height: `${size}px`,
            overflow: "visible",
            zIndex: 99,
          }
    }
  >
    <motion.path
      d="M 0, 20 a 20, 20 0 1,0 40,0 a 20, 20 0 1,0 -40,0"
      animate={{
        strokeDasharray: [125, 125],
        strokeDashoffset: [0, 250],
      }}
      transition={{ duration: 2, loop: Infinity }}
      fill="none"
      stroke={color}
      strokeWidth="5"
      strokeAlignment="inside"
    />
  </svg>
);

BasicLoader.propTypes = {
  color: PropTypes.string,
  position: PropTypes.oneOf(["absolute", "relative"]),
  size: PropTypes.number,
};

BasicLoader.defaultProps = {
  color: "#ecebeb",
  position: "absolute",
  size: 40,
};

export default BasicLoader;
